export default function asideMobileOpener() {
  $('.mobile-header-holder').on('click', function (event) {
    event.preventDefault();
    $('#sidebar').toggleClass('active');
    if ($('#sidebar').hasClass('active')) {
      $('#sidebar .drop-container').slideDown();
    } else {
      $('#sidebar .drop-container').slideUp();
    }
  });
}